// StreamingMarkdown.jsx — A5 live-lane markdown renderer (the MANDATED V1 renderer).
//
// The streaming typewriter lane used to render `{text}` as raw text + a hardcoded `▋` cursor,
// so mid-stream `**bold**`, lists, and code blocks showed as literal syntax, then "converted"
// to rich markdown only when the turn settled (the #1/#2/#4 convert-flip). This component renders
// the live lane as RICH markdown from the first frame:
//
//   react-markdown@10  +  the SHARED constrained COMPONENTS map  +  repairStreamingMarkdown(text)
//
// The repair pass closes dangling `**`/fences/list-bullets each frame so partial markdown never
// flashes half-syntax. The blinking cursor is now CSS (.st-msg--live::after, owned by the SCSS
// slice) — there is NO hardcoded `▋` literal here.
//
// SAFETY: inherits the same constrained, NO-rehype-raw subset as AssistantMarkdown — model text
// is untrusted; raw HTML renders inert. This and AssistantMarkdown are the ONLY react-markdown
// importers in the shell (isolation contract).

import React from "react"
import ReactMarkdown from "react-markdown"
import { COMPONENTS, REMARK_PLUGINS } from "./assistantMarkdownComponents.jsx"
import { repairStreamingMarkdown } from "./repairStreamingMarkdown.js"

/**
 * Render a mid-stream assistant delta as rich, repaired markdown.
 * @param {{ text?: string }} props
 */
export default function StreamingMarkdown({ text }) {
  return (
    <div className="st-md">
      <ReactMarkdown components={COMPONENTS} remarkPlugins={REMARK_PLUGINS}>
        {repairStreamingMarkdown(text || "")}
      </ReactMarkdown>
    </div>
  )
}
